export default __webpack_public_path__ + "static/media/remove.46078088.svg";